module.exports = __webpack_public_path__ + "static/media/project_logo_mapleitem.a9b4a49b.png";